// features/Users.js
import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    isAuthenticated: false,
    data: null,
  },
  reducers: {
    login: (state, action) => {
      state.isAuthenticated = true;
      state.data = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.data = null;
    },
  },
});

export const { login, logout } = userSlice.actions;

export default userSlice.reducer;
